(ns ui.view.card.counterparty-diligence-docs.view
  (:require
   [common.localization :as loc]
   [frontend.utils :as fu]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.view.card.counterparty-diligence-docs.event :as event]
   [ui.view.card.counterparty-diligence-docs.sub :as sub]
   [ui.view.card.event :as common-event]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.card-title :as card-title]                               ;; TODO remove
   [ui.view.esign.event :as esign-event]
   [ui.view.esign.signatory-table :as signatory-table]))

(defn responder-submission-view
  [{:keys [ctx] :as _props}]
  (let [latest-process @(rf/subscribe [::sub/latest-process ctx])]
    [:div
     {:class "flex flex-col gap-2"}
     [:p
      {:class "font-semibold"}
      (loc/tr :responders-submission)]

     (if (-> latest-process
             :counterparty-diligence-process/answers
             seq)
       [:div
        {:class "flex gap-2"}
        [button/sm-secondary-hollow
         {:on-click #(rf/dispatch [::event/open-answers-pdf ctx])
          :class    "w-64"}
         [:i {:class "fal fa-file"}]
         (loc/tr :view-answers-as-pdf)]]
       [:div
        [:p
         {:class "text-base-light-text-paler"}
         (loc/tr :counterparty-diligence-docs-responder-submission-draft-info)]])]))

(defn attachment-item
  [attachment]
  (let [{:keys [db/id attachment/filename]} attachment]
    [:div
     {:class "flex items-center px-3 py-2 justify-between border rounded shadow"}
     [:div
      {:class "flex items-center gap-2"}
      [:i
       {:class "fal fa-file-pdf"}]
      [:p filename]]
     [:div
      {:class "flex items-center gap-2"}
      [button/square-secondary-hollow
       {:on-click #(fu/open-attachment! id)}
       [:i {:class "fal fa-external-link"}]]

      [button/square-secondary-hollow
       {:on-click #(fu/download-attachment! id)}
       [:i {:class "fal fa-cloud-download"}]]]]))

(defn e-signature-view
  [{:keys [ctx]}]
  (let [esign-process @(rf/subscribe [::sub/esign-process ctx])
        signatories @(rf/subscribe [::sub/signatories ctx])
        signed-document @(rf/subscribe [::sub/esigned-answers-document ctx])]
    [:div
     {:class "flex flex-col gap-8"}
     [:div
      {:class "flex flex-col gap-2 w-96"}
      [:p {:class "font-semibold"}
       (loc/tr :esigned-document)]
      (if signed-document
        [attachment-item
         ;; TODO: What should be the filename
         (assoc signed-document
           :attachment/filename "signed-document.pdf")]
        [:p
         {:class "text-base-light-text-paler"}
         (loc/tr :esigned-document-will-show-here-once-ready)])]
     [:div
      {:class "flex flex-col gap-2"}
      [:p
       {:class "font-semibold"}
       (loc/tr :signatories)]
      (if (seq signatories)
        [signatory-table/view
         {:signatories                signatories
          :send-reminder-to-signatory (fn [{:keys [signatory-id signatory-email]}]
                                        (rf/dispatch [::esign-event/send-reminder-to-signatory
                                                      {:esign-process-id (:db/id esign-process)
                                                       :signatory-id     signatory-id
                                                       :signatory-email  signatory-email
                                                       :success-event    [::common-event/fetch-card-data ctx]}]))}]
        [:p
         {:class "text-base-light-text-paler"}
         (loc/tr :responder-has-not-filled-any-signatories-yet)])]]))

(defn content
  [{:keys [ctx] :as props}]
  (let [e-signature-required? @(rf/subscribe [::sub/e-signature-required? ctx])]
    [:div
     {:class "grid grid-cols-1 gap-10 mb-5"}
     [responder-submission-view props]
     (when e-signature-required?
       [e-signature-view props])]))

(defn view
  [{:keys [card] :as props}]
  [card-container/view
   {}
   [:div
    {:class "flex flex-col gap-4"}
    [:div
     {:class "flex justify-between"}
     [card-title/view (:card/title card)]]
    [content props]]])
